import { Link } from 'react-router-dom';
import { SrOnly } from '@skyslope/mache';

import FormsLogo from 'assets/images/ss-apps/SkySlope.svg';
import { routes } from 'constants/routes';

export function FormsLogoLink() {
  return (
    <Link to={routes.homeTownBuffet} id="files-dashboard-link" className="shrink-0">
      <SrOnly>Go to files dashboard</SrOnly>
      <img alt="" src={FormsLogo} width={120} height={30} />
    </Link>
  );
}
